import { Component, OnInit, Inject } from '@angular/core';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'app/services/general.service';
import {DatePipe} from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';
@Component({
  selector: 'app-modal-comunicado',
  templateUrl: './modal-comunicado.component.html',
  styleUrls: ['./modal-comunicado.component.scss']
})
export class ModalComunicadoComponent implements OnInit {

  data: any = {};

  hasBaseDropZoneOver = false;
  loadBtn = false;

  showDrop=true;

  dataForeign: any = {};
    private base64textString: String = '';
    base64Pdf: string;
    filesUpload = 0;
    filesArr = [];
    cpCompany: any;
    diatanceCdfi: any;
    alertDistance = false;
    filesCountUpload = 0;

    step = 1;
    msgResp: any;
    txtHead = 'BUTTONS.ADDINVOICE';
    totalSelect: any;
    info: any = {};
    update = false;
    noticeId;
    uploader: FileUploader = new FileUploader({
      url: URL,
      isHTML5: true
    });

  constructor(
    private toastr: ToastrService,
    private gralService: GeneralService,
    public dialogRef: MatDialogRef<ModalComunicadoComponent>, @Inject(MAT_DIALOG_DATA) public dataInfo: any
    ) {
    console.log(this.dataInfo);
    this.update = this.dataInfo.update;
    if(this.update){
      this.noticeId = this.dataInfo.noticeId;
      setTimeout(()=>{
        this.infoNotice();
       }, 1000)
    }

  }

  ngOnInit() {
    this.data.FechaFin = new Date();
  }

  upp(evt){
    console.log('entro a up ')
    const file = evt.dataTransfer ? evt.dataTransfer.files[0] : evt.target.files[0];
    this.fileUpload(file);
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  dropped(e){
    for(let g = 0; g < e.length; g++){
      this.fileUpload(e[g]);
    }
  }

  fileUpload(file){

    const patternPdf = /pdf/;

    if (!file.type.match(patternPdf)) {
      this.toastr.error('El archivo ' + file.name + ' tiene formato de archivo inválido, solo se acepta pdf', 'Error al cargar archivo');
        return false;
    }

    this.filesArr.push({file: file, name: file.name, size: file.size, color: 'green', type: 'pdf', date: null, error: null, id: null, url: 'http://concent.com.mx'});
    this.showDrop = false;
  }

  _loadPdf(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64Pdf = btoa(binaryString);
    this.info.ComunicadoPDFBase64 = btoa(binaryString);
  }

  deleteFile(idx){
    this.filesArr.splice(idx, 1);
    this.filesCountUpload--;
    this.showDrop = true;
  }

  sendComunicate(){
    const datePipe = new DatePipe('en-US');
    this.loadBtn = true;

    if(this.filesArr.length == 0){
      this.toastr.error('Favor de agregar archivo pdf', 'Error al cargar archivo');
      this.loadBtn = false;
      return false;
    }

    if(!this.data.titulo || !this.data.FechaInicio || !this.data.FechaFin ){
      this.toastr.error('Favor de ingresar todos los campos', 'Error');
      this.loadBtn = false;
      return false;
    }

    if(this.filesArr[0].type == 'pdf'){
      const reader = new FileReader();
      reader.onload = this._loadPdf.bind(this);
      reader.readAsBinaryString(this.filesArr[0].file);
    }

    this.info = {
      Titulo: this.data.titulo,
      FechaInicio: datePipe.transform(this.data.FechaInicio, 'yyyy-MM-dd'),
      FechaFin: datePipe.transform(this.data.FechaFin, 'yyyy-MM-dd')
    }

    setTimeout(()=>{
      this.gralService.addNotice(this.info, '').then((res:any)=>{
        console.log(res)
        this.loadBtn = false;
        this.dialogRef.close({update: true});
      });

    }, 1000);

  }

  onCloseCancel() {
    this.dialogRef.close();
  }

  infoNotice(){
    this.gralService.getSingleNote(this.noticeId, '123').then((res:any)=>{
      if(res.Entidad){
        this.data.titulo = res.Entidad.Titulo;
        this.data.FechaInicio = res.Entidad.FechaInicio;
        this.data.FechaFin = res.Entidad.FechaFin;
      }

    });
  }

  sendUpdate(){
    const datePipe = new DatePipe('en-US');
    let params = {
      Titulo: this.data.titulo,
      FechaInicio: datePipe.transform(this.data.FechaInicio, 'yyyy-MM-dd'),
      FechaFin: datePipe.transform(this.data.FechaFin, 'yyyy-MM-dd')
    }
    this.gralService.updateNote(this.noticeId, params, '123').then((res:any)=>{
      this.toastr.success('Comunicado actualizado correctamente', '');
        this.loadBtn = false;
        this.dialogRef.close({update: true});
    }, error=>{
      console.warn(error);
    });
  }

}
